import { Link } from 'react-router-dom';

export default function JapanHeader() {
  return (
    <nav className="nav">
      <div className="nav-left">
        <h1><Link to="/">🐾 ZS動物シェルター 🐾</Link></h1>
      </div>
      <nav className="nav-right">
        <Link to="/">HOME</Link>
        <Link to="/stories">DIARY</Link>
        <Link to="/about">ABOUT</Link>
        <a href="https://example.com/donate" className="donate-btn">DONATE</a>
      </nav>
    </nav>
  );
}
